import { tokens } from "../../theme/theme";
import { Divider, Typography, Card, CardContent, Grid, CardHeader, IconButton, Button, useTheme, Box, Badge, } from "@mui/material";
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import ListAltIcon from '@mui/icons-material/ListAlt';
import DescriptionIcon from '@mui/icons-material/Description';
import SummarizeIcon from '@mui/icons-material/Summarize';

// icons 
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useTranslation } from "react-i18next";


const BillOfMaterialMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();


    const callback = () => {
        handleBackDashboard();
    };

    const DashboardCard = ({ title, icon, onClick, badge, subtitle }) => (
        <Card
            elevation={3}
            sx={{
                backgroundColor: colors.primary[400],
                borderRadius: 3,
                p: 3,
                textAlign: "center",
                transition: "0.3s",
                "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: theme.shadows[6],
                },
            }}
        >
            <Box
                sx={{
                    width: 60,
                    height: 60,
                    mx: "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: colors.primary[400],
                    borderRadius: "50%",
                    mb: 2,
                }}
            >
                {badge ? (
                    <Badge
                        badgeContent={badge}
                        color="error"
                        overlap="circular"
                        sx={{
                            "& .MuiBadge-badge": {
                                fontSize: "10px",
                                height: "16px",
                                minWidth: "16px",
                                padding: "0 4px",
                            },
                        }}
                    >
                        {icon}
                    </Badge>
                ) : (
                    icon
                )}
            </Box>

            <Typography variant="h6" fontWeight={600}>
                {title}
            </Typography>

            <Button
                variant="contained"
                color="secondary"
                sx={{ mt: 2 }}
                onClick={onClick}
            >
                {subtitle}
            </Button>
        </Card>
    );

    return (
        <Box >

            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center" >
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">
                            {/* {t('prod_menu.productionmanagement')} */}
                            Bill of Materials (BOM)
                        </Typography>
                    </Box>
                </CardContent>
            </Card>

            {/* scan bar code */}
            {/* <Divider /> */}
            <Box mt={.5} display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" justifyContent="space-between" alignItems="center">

                </Box>

                <Box display="flex"
                    mr={1}
                    gridColumn={{
                        xs: 'span 2',
                        sm: 'span 3',
                        md: 'span 3',
                        lg: 'span 2',
                        xl: 'span 2',
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderStyle: 'dashed', // Set border style to dashed
                            }
                        }
                    }}
                >

                    <IconButton aria-label="stock-upload" onClick={() => SetActive("ViewDocumentSequence")} style={{ borderRadius: '8px', marginRight: '10px' }}>
                        <SettingsSuggestIcon style={{ color: "#2e7d32" }} />
                        <Typography textTransform={'none'} variant="button" style={{ marginLeft: '10px' }}>{t('prod_menu.documentsequencesettings')} </Typography>
                    </IconButton>
                    <IconButton aria-label="stock-upload" onClick={() => SetActive("ViewQRCodeSettings")} style={{ borderRadius: '8px', marginRight: '10px' }}>
                        <QrCodeScannerIcon style={{ color: "#ba68c8" }} />
                        <Typography textTransform={'none'} variant="button" style={{ marginLeft: '10px' }}>{t('prod_menu.qrcodeconfiguration')}</Typography>
                    </IconButton>
                </Box>
            </Box>
            <Divider />

            {/* <Divider /> */}
            <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="0px"  >
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <DashboardCard
                                title={t('bom_menu.bom_master')}
                                icon={<ListAltIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("billofmaterialmaster")}
                                subtitle="Add"
                            />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <DashboardCard
                                title={t('bom_menu.bom_planning')}
                                icon={<DescriptionIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("billofmaterialplan")}
                                subtitle="Get"
                            />
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>                       
                          <DashboardCard
                                title={t('bom_menu.bom_list')}
                                icon={<SummarizeIcon fontSize="large" color="secondary" />}
                                onClick={() => SetActive("billofmaterial")}
                                subtitle="Get"
                            />
                    </Grid>

                    {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <ReceiptIcon fontSize="large" />
                            <Typography variant="h6" mt={2}>Costing</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("costing")}>Get</Button>
                        </Card>
                    </Grid> */}





                    {/* Repeat the Grid item for each production entry */}
                    {/* You can customize the style and content for each card */}
                </Grid>
            </Box>
        </Box>

    )
}
export default BillOfMaterialMenu;





